import Skeleton from "react-loading-skeleton";
import styles from "./cartPage.module.scss";

export const CartSkeleton = () => {
  return (
    <div className={styles.cardSkeleton}>
      <div className={styles.headerSkeleton}>
        <div className={styles.skeleton}>
          <Skeleton height={"60px"} width={"20%"} />
        </div>
      </div>
      <div className={styles.cardWrapper}>
        <div className={styles.cards}>
          <div className={styles.topAds}>
            <div className={styles.skeleton}>
              <Skeleton height={"60px"} width={"100%"} />
            </div>
          </div>
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className={styles.skeleton}>
              <Skeleton height={"160px"} width={"100%"} />
            </div>
          ))}
        </div>
        <div className={styles.rightSection}>
          <div className={styles.skeleton}>
            <Skeleton height={"360px"} width={"100%"} />
          </div>
        </div>
      </div>
    </div>
  );
};
